export default "__VITE_PUBLIC_ASSET__db999ea9__"